
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/route/[id]",
      function () {
        return require("private-next-pages/route/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/route/[id]"])
      });
    }
  